import { Reveal } from "./Reveal";

export const Overline = ({ children, light = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2 text-xs md:text-sm uppercase tracking-[0.22em] font-accent font-semibold ${light ? "text-dash-teal" : "text-dash-teal"} ${className}`}>
    <span className="h-px w-8 bg-dash-teal/60" />
    {children}
  </span>
);

export const SectionHeading = ({ overline, title, subtitle, light = false, center = false, className = "" }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
    <Reveal>
      {overline && <div className={center ? "flex justify-center" : ""}><Overline light={light}>{overline}</Overline></div>}
    </Reveal>
    <Reveal delay={0.05}>
      <h2 className={`mt-5 font-display text-4xl md:text-5xl font-bold tracking-tight leading-[1.08] text-balance ${light ? "text-white" : "text-dash-ink"}`}>
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.1}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-white/70" : "text-dash-muted"}`}>{subtitle}</p>
      </Reveal>
    )}
  </div>
);
